import { useMutation } from '@tanstack/react-query';
import { createPartnerInvitation } from '~apis/company/partnerInvitation';

/** 파트너 초대 생성 뮤테이션 훅 */
export function useCreatePartnerInvitation() {
  return useMutation({
    mutationFn: createPartnerInvitation,
  });
}
